import React, { useState, useEffect, useRef } from 'react';
import { useEventActions } from './EventContext';
import EventLoader from './EventLoader';
import EventPublishingWorkflowControls from './EventPublishingWorkflowControls';
import EventMainImage from './EventMainImage';
import EventTitle from './EventTitle';
import EventDetails from './EventDetails';
import EventBreakdown from './EventBreakdown';
import EventDescription from './EventDescription';
import { DocumentManager } from '../../RichTextEditor';
import EventRSVP from './EventRSVP';
import EventAdminSection from './EventAdminSection';

const Event = ({
  id,
  authenticatedUser,
  startInEditMode,
  timezones,
}) => {
  const { initializeState } = useEventActions();
  const initializedIdRef = useRef(null);
  const [documentManagerWrapperState, setDocumentManagerWrapperState] = useState({
    documentManager: new DocumentManager({
      id: null,
      startDocumentComponentType: 'DocumentParagraph'
    }),
  });

  useEffect(() => {
    if (id && initializedIdRef.current !== id) {
      initializedIdRef.current = id;
      initializeState(authenticatedUser, id, startInEditMode, timezones);
    }
  }, [id]);

  return (
    <>
      <EventLoader />
      <EventPublishingWorkflowControls
        documentManagerWrapperState={documentManagerWrapperState}
      />
      <EventMainImage />
      <EventTitle />
      <EventDetails />
      <EventBreakdown />
      <EventDescription
        documentManagerWrapperState={documentManagerWrapperState}
        setDocumentManagerWrapperState={setDocumentManagerWrapperState}
      />
      <EventRSVP />
      <EventAdminSection />
    </>
  );
};

export default Event;
